<template>
	<footer v-if="!customFooter">
		<div id="footer" class="site-footer">
			<div class="site-footer__main">
					<div class="">
						<img :src="redClioLogo" class="site-footer__main-logo" alt="Clio Muse Tours logo">
						<div class="site-footer__title" v-html ="$t('footer.title')"></div>
					</div>
					<div class="site-footer__main-text">
						<div class="site-footer__custom_title">
							{{ $t('footer.contact_title') }}
						</div>
						<p>
							<span class="accented" style="font-weight: 500;">{{ $t('footer.contact_hours') }}</span>
						</p>
						<p>
							<a :href="'https://wa.me/?text=' + referenceNumber + '&phone=' + appInfo.cc_whatsapp" @click="trackSupport('whatsapp')">{{ $t('footer.contact_whatsapp', {tel: appInfo.cc_whatsapp}) }}</a>
							<br>
								<a :href="'tel:' + appInfo.cc_phonecall" @click="trackSupport('phone')">{{ $t('footer.contact_call') }} {{ appInfo.cc_phonecall }}</a>
							<br>
							<a :href="'mailto:' + appInfo.cc_email" @click="trackSupport('email')">{{ $t('footer.contact_email', {email: appInfo.cc_email}) }}</a>
						</p>
					</div>
					<div class="site-footer__main-text">
						<div>
							<ul class="social-media-menu">
								<li class="social-media-menu__item">
									<a :href="appInfo.facebook_link" target="_blank" title="Clio Muse Tours on Facebook" class="social-media-menu__link" rel="noopener noreferrer" @click="trackSocial('facebook')">
										<img :src="redFacebook" class="social-media-menu__icon" alt="Facebook icon">
									</a>
								</li>
								<li class="social-media-menu__item">
									<a :href="appInfo.instagram_link" target="_blank" title="Clio Muse Tours on Instagram" class="social-media-menu__link" rel="noopener noreferrer" @click="trackSocial('instagram')">
										<img :src="redInstagram" class="social-media-menu__icon" alt="Instagram icon">
									</a>
								</li>
								<li class="social-media-menu__item">
									<a :href="appInfo.linkedin_link" target="_blank" title="Clio Muse Tours on LinkedIn" class="social-media-menu__link" rel="noopener noreferrer" @click="trackSocial('linkedin')">
										<img :src="redLinkedIn" class="social-media-menu__icon" alt="LinkedIn icon">
									</a>
								</li>
								<li class="social-media-menu__item">
									<a :href="appInfo.tiktok_link" target="_blank" title="Clio Muse Tours on TikTok" class="social-media-menu__link" rel="noopener noreferrer" @click="trackSocial('tiktok')">
										<img :src="redTikTok" class="social-media-menu__icon" alt="TikTok icon">
									</a>
								</li>
							</ul>
						</div>
						<br>
						<p style="font-weight: 500;">
							{{ $t('footer.download_title') }}
						</p>
						<ul class="download-app-store-list text">
							<li class="download-app-store-list__item">
								<a :href="appInfo.app_store_link" title="Download Clio Muse Tours on the App Store" target="_blank" rel="noopener noreferrer">
									<img :src="appStore" class="download-app-store-list__item-image" alt="Download on the App Store" @click="trackAppDownload('ios')">
								</a>
							</li>
							<li class="download-app-store-list__item">
								<a :href="appInfo.playstore_link" title="Download Clio Muse Tours on Google Play" target="_blank" rel="noopener noreferrer">
									<img :src="googlePlay" class="download-app-store-list__item-image" alt="Download on Google Play" @click="trackAppDownload('android')">
								</a>
							</li>
						</ul>
					</div>
				</div>
			<div class="site-footer__subfooter">
				<div>
					<br>
				</div>
			</div>
		</div>

		<div id="footerSmall" class="site-footer">
			<div class="site-footer__top">
				<div class="wrapper">
					<div class="site-footer__top-container">
						<div class="site-footer__top-logo">
							<img :src="redClioLogo" class="site-footer__top-logo-image" alt="Clio Muse Tours logo" title="Clio Muse Tours">
						</div>
						<div class="site-footer__top-social">
							<ul class="social-media-menu">
								<li class="social-media-menu__item">
									<a :href="appInfo.facebook_link" target="_blank" title="Clio Muse Tours on Facebook" class="social-media-menu__link" rel="noopener noreferrer" @click="trackSocial('facebook')">
										<img :src="redFacebook" class="social-media-menu__icon" alt="Facebook icon">
									</a>
								</li>
								<li class="social-media-menu__item">
									<a :href="appInfo.instagram_link" target="_blank" title="Clio Muse Tours on Instagram" class="social-media-menu__link" rel="noopener noreferrer" @click="trackSocial('instagram')">
										<img :src="redInstagram" class="social-media-menu__icon" alt="Instagram icon">
									</a>
								</li>
								<li class="social-media-menu__item">
									<a :href="appInfo.linkedin_link" target="_blank" title="Clio Muse Tours on LinkedIn" class="social-media-menu__link" rel="noopener noreferrer" @click="trackSocial('linkedin')">
										<img :src="redLinkedIn" class="social-media-menu__icon" alt="LinkedIn icon">
									</a>
								</li>
								<li class="social-media-menu__item">
									<a :href="appInfo.tiktok_link" target="_blank" title="Clio Muse Tours on TikTok" class="social-media-menu__link" rel="noopener noreferrer" @click="trackSocial('tiktok')">
										<img :src="redTikTok" class="social-media-menu__icon" alt="TikTok icon">
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="site-footer__main">
				<div class="site-footer__main">
					<div class="wrapper">
						<div class="site-footer__main-text">
							<div class="site-footer__main-text__elem">
								<div class="site-footer__main-text__elem__text">
									<span class="accented" style="font-weight: 500;">{{ $t('footer.contact_hours') }}</span>
									<br>
									<a :href="'https://wa.me/?text=' + referenceNumber + '&phone=' + appInfo.cc_whatsapp" @click="trackSupport('whatsapp')">{{ $t('footer.contact_whatsapp', {tel: appInfo.cc_whatsapp}) }}</a>
								</div>
								<a :href="'https://wa.me/?text=' + referenceNumber + '&phone=' + appInfo.cc_whatsapp" class="site-footer__main-text__elem__image" @click="trackSupport('whatsapp')">
									<img :src="whatsApp" alt="WhatsApp icon">
								</a>
							</div>
							<div class="site-footer__main-text__elem" @click="trackSupport('phone')">
								<div class="site-footer__main-text__elem__text">
									<a :href="'tel:' + appInfo.cc_phonecall">{{ $t('footer.contact_call') }}{{ appInfo.cc_phonecall }}</a>
								</div>
								<a :href="'tel:' + appInfo.cc_phonecall" class="site-footer__main-text__elem__image">
									<img :src="phone" alt="Phone icon">
								</a>
							</div>
							<div class="site-footer__main-text__elem">
								<div class="site-footer__main-text__elem__text" @click="trackSupport('email')">
									<a :href="'mailto:' + appInfo.cc_email">{{ $t('footer.contact_email', {email: appInfo.cc_email}) }}</a>
								</div>
							</div>
						</div>
						<div class="site-footer__main-text centered">
							<ul class="download-app-store-list text text--centered">
								<li class="download-app-store-list__item">
									<a :href="appInfo.app_store_link" title="Download Clio Muse Tours on the App Store" target="_blank" rel="noopener noreferrer">
										<img :src="appStore" class="download-app-store-list__item-image" alt="Download on the App Store" @click="trackAppDownload('ios')">
									</a>
								</li>
								<li class="download-app-store-list__item">
									<a :href="appInfo.playstore_link" title="Download Clio Muse Tours on Google Play" target="_blank" rel="noopener noreferrer">
										<img :src="googlePlay" class="download-app-store-list__item-image" alt="Download on Google Play" @click="trackAppDownload('android')">
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="site-footer__subfooter">
				<div class="wrapper">
					<br>
				</div>
			</div>  
		</div>
	</footer>

	<!-- Branded Version -->
	<footer v-else>
		<div class="footer__custom">
			<!-- Mobile View -->
			<div class="footer__custom--mobile wrapper">
				<div class="section">
					<BrandLogo v-if="hasValidPartner" :clioLogo="false" :partnerLogo="partnerLogo" :partnerTitle="partnerTitle"/>
					<img v-else class="site-footer__main-logo" :src="redClioLogo" alt="Clio Muse Tours logo">
					<p>{{ $t('footer.custom_title') }}</p>
					<div class="site-footer__custom_title">{{ $t('footer.contact_title') }}</div>
					<div class="footer__custom__subsection">
						<a :href="'https://wa.me/?text=' + referenceNumber + '&phone=' + appInfo.cc_whatsapp" @click="trackSupport('whatsapp')">
							<img class="footer__custom__logo"  style="margin-right: .4rem;" :src="brandedWhatsApp" alt="WhatsApp icon">
							{{ $t('footer.custom_whatsapp', {tel: appInfo.cc_whatsapp}) }}
						</a>
					</div>
					<div class="footer__custom__subsection">
						<a :href="'tel:' + appInfo.cc_phonecall">
							<img class="footer__custom__logo"  style="margin-right: .4rem;" :src="brandedPhone" alt="Phone icon">
							<span>{{ appInfo.cc_phonecall }}</span>
						</a>
					</div>
					<div class="footer__custom__subsection">
						<a :href="'mailto:' + appInfo.cc_email" @click="trackSupport('email')">
							<img class="footer__custom__logo"  style="margin-right: .4rem;" :src="brandedEmail" alt="Email">
							<span>{{ appInfo.cc_email }}</span>
						</a>
					</div>
				</div>
				<div class="line"><hr></div>
				<div class="section">
					<p style="display: flex; align-items: center;">{{ $t('footer.supported_by') }}
						<img class="footer__custom__logo" src="/icons/clio_logo.jpg" style="margin-left: .4rem; margin-right: .4rem;" alt="Clio Muse Tours logo">
						Clio Muse Tours
					</p>
					<p class="footer__custom__copyright">© {{ new Date().getFullYear() }} {{ $t('footer.copyright') }} | {{ $t('footer.rights_reserved') }}</p>
				</div>
			</div>

			<!-- Desktop View -->
			<div class="footer__custom--desktop wrapper">
				<div class="section footer__custom__row section--no-padding-bottom">
					<BrandLogo v-if="hasValidPartner" :clioLogo="false" :partnerLogo="partnerLogo" :partnerTitle="partnerTitle"/>
					<img v-else class="site-footer__main-logo" :src="redClioLogo" alt="Clio Muse Tours logo">
				</div>
				<div class="footer__custom__row section--padding-top-short section">
					<div class="footer__custom__column footer__custom__column-footer">
						<p>{{ $t('footer.custom_title') }}</p>
					</div>
					<div class="footer__custom__column footer__custom__column-footer">
						<div class="site-footer__custom_title" style="margin: 0; margin-left: 6rem;">{{ $t('footer.contact_title') }}</div>
					</div>
					<div class="footer__custom__column footer__custom__column-footer" @click="trackSupport('whatsapp')">
						<img class="footer__custom__logo" style="margin-right: .3rem;" :src="brandedWhatsApp" alt="WhatsApp icon">
						<a :href="'https://wa.me/?text=' + referenceNumber + '&phone=' + appInfo.cc_whatsapp">
							{{ $t('footer.custom_whatsapp', {tel: appInfo.cc_whatsapp}) }}
						</a>
					</div>
					<div class="footer__custom__column footer__custom__column-footer">
						<img class="footer__custom__logo"  style="margin-right: .3rem;" :src="brandedPhone" alt="Phone icon">
						<span>{{  appInfo.cc_phonecall }}</span>
					</div>
					<div class="footer__custom__column footer__custom__column-footer">
						<a :href="'mailto:' + appInfo.cc_email" @click="trackSupport('email')">
							<img class="footer__custom__logo"  style="margin-right: .3rem;" :src="brandedEmail" alt="Email">
							<span>{{ appInfo.cc_email }}</span>
						</a>
					</div>
				</div>
				<div class="line"><hr></div>
				<div class="footer__custom__row section section--padding-top-short">
					<div class="footer__custom__column">
					<p style="display: flex; align-items: center;">{{ $t('footer.supported_by') }}
						<img class="footer__custom__logo" src="/icons/clio_logo.jpg" style="margin-left: .4rem; margin-right: .4rem;" alt="Logo">
						Clio Muse Tours
					</p>
					</div>
					<div class="footer__custom__column" style="justify-content: flex-end;" >
						<p class="footer__custom__copyright">© {{ new Date().getFullYear() }} {{ $t('footer.copyright') }} | {{ $t('footer.rights_reserved') }}</p>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import info from '~/data/info.json';
import BrandLogo from './BrandLogo.vue';

  export default {
	components: {
		BrandLogo
	},
	data() {
		return {
			appInfo: info,
        	redClioLogo: '/icons/clio-muse-tours-logo-red.svg',
			// Social media
			redFacebook: '/icons/social-media-icons/facebook-red.svg',
			redInstagram: '/icons/social-media-icons/instagram-red.svg',
			redLinkedIn: '/icons/social-media-icons/linkedin-red.svg',
			redTikTok: '/icons/social-media-icons/tiktok-red.svg',
			// App stores
			appStore: '/icons/app-stores/app-store.svg',
			googlePlay: '/icons/app-stores/google-play.svg',
			// CC
			whatsApp: '/icons/contact-icons/whatsapp.svg',
			phone: '/icons/contact-icons/phone.svg',
			brandedWhatsApp: '/icons/contact-icons/branded/whatsapp.png',
			brandedPhone: '/icons/contact-icons/branded/phone.png',
			brandedEmail: '/icons/contact-icons/branded/email.png'
		}
	},
    props: {
        customFooter: {
          default: false,
          type: Boolean
        },
		partner: {
          default: false,
          type: Boolean
        },
		partnerName: {
          default: '',
          type: String
        },
		partnerTitle: {
          default: '',
          type: String
        },
		partnerLogo: {
          default: '',
          type: String
        },
		referenceNumber: {
          default: '',
          type: String
        }
    },
	computed: {
		hasValidPartner() {
			return this.partner && this.partnerLogo && this.partnerTitle;
		}
	},
	methods: {
		trackSocial(social_type) {
			if (typeof window.gtag === 'function') {
				window.gtag('event', 'click_social', {
					social_type: social_type
				})
			}
		},
		trackAppDownload(platform) {
			if (typeof window.gtag === 'function') {
				window.gtag('event', 'click_app_download', {
					platform: platform
				})
			}
		},
		trackSupport(support_type) {
			if (typeof window.gtag === 'function') {
				window.gtag('event', 'click_support', {
					support_type: support_type
				})
			}
		}
	}
  };
</script>